import { z } from 'zod';

import { NavLinkImageDetails } from './nav-link-image-details';

export const NavColumn = z.object({
  link_title: z.nullable(z.string()),
  mobile_title: z.nullable(z.string()),
  link_url: z.nullable(z.string()),
  link_description: z.nullable(z.string()),
  link_icon: z.nullable(z.string()),
  link_image_details: z.nullable(NavLinkImageDetails),
  link_image_overlay: z.nullable(z.string()),
  link_image_style: z.nullable(z.string()),
  link_image_url: z.nullable(z.string()),
  link_style: z.nullable(z.array(z.string())),
  logged_in: z.nullable(z.string()),
});

export type NavColumn = z.infer<typeof NavColumn>;
